import * as Validators from 'vuelidate/lib/validators'

function isOlderThan18(dob) {
  if (dob === null) return true
  const dateArray = dob.split('-')
  const dateYMD = [...dateArray.slice(-1), ...dateArray.slice(0, 2)].join('-')
  const dobAsDate = new Date(dateYMD)
  const today = new Date()
  const diff = new Date(today - dobAsDate)
  return diff.getUTCFullYear() - 1970 >= 18
}

const USPhoneNumber = Validators.helpers.regex(
  'USPhoneNumberFormat',
  /^[2-9][0-9]{2}-[0-9]{3}-[0-9]{4}$/
)

const date = Validators.helpers.regex(
  'date',
  /^(0[1-9]|1[0-2])-(0[1-9]|[1|2][0-9]|3[01])-(19|20)\d{2}$/
)

const withCustomValidators = { ...Validators, isOlderThan18, USPhoneNumber, date }

export const buildValidator = (validationKey, input, formModel) => {
  if (validationKey === 'required' && input.dependOnFieldId) {
    return Validators.requiredIf(() => {
			return input.dependOnFieldValue.split(',').some(v => formModel[input.dependOnFieldId]?.includes(v))
		})
  }

  return withCustomValidators[validationKey]
}

export default withCustomValidators
